import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Dashboard {

  list:any;  
  constructor(public api:Api, public user:User) { 

  }

  getAdvanceStat(params?: any){
    return this.api.get('index.php/advance/dashboard/advance_stat', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/advance_providers/dashboard/dashboard.ts